import { createSelector } from 'reselect';

import { getBuilder } from './getBuilder';

export const getCurrentRobotId = createSelector(
  getBuilder,
  builder => builder.currentRobotId
);
